import { BCMSRecord, DisabledPrompt, Link, ModalOpen, useRoute, useRouteData, useWorkflowStep ,useModel} from "@bcm-dev/bcms-vite";
import { getDefaultRequest, getWorkflowSteps } from "compid/workflows/RequestEBill";
import { Bill, Biller } from "model";


import ButtonContainer from "compid/shared/containers/ButtonContainer";
import LayoutContainer from "compid/shared/containers/LayoutContainer";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import LeftColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/LeftColumnContainer";
import RightColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/RightColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import BillerView from "compid/shared/views/BillerView";
import UIButton from "compid/ui/UIButton";
import UITextInput from "compid/ui/UITextInput";
import { SVGAsset } from "res";
import RequestEBillWidget from "./components/RequestEBillWidget";
import "./styles.css";

export default function RequestEBillPage(props) {
  // Initalize the workflowStep and model classes
  const workflowStep = useWorkflowStep(getDefaultRequest, getWorkflowSteps);
  BCMSRecord.globalControllerFor([ Biller, Bill ], workflowStep.globalController);
const {  profile } = useModel();
  const biller = workflowStep.read("biller");
  const submit = evt => {
    // Update the biller status to 'Active'
    workflowStep.update(["biller", "eBillStatus"], "Active");
    
    // Update the connected Bill to a status of 'Due'
    const bill = Bill.getBillByBiller(biller.id);
    bill.status = "Due";

    // Batch the updates together and update state
    BCMSRecord.batch([
      Biller.update(biller),
      Bill.update(bill)
    ], workflowStep.globalController);

    // If we are inside the workflow, go to next step otherwise route to the workflow passing the id, step number, and state
    try {
      workflowStep.workflow.nextStep(workflowStep.getStepState);
    } catch(error) {
      workflowStep.navigate(`/requestEBillWorkflow/${ biller.id }/${ workflowStep.currentStep + 1 }`, { state: workflowStep.getStepState });
    }
  };

  return(
    <PageView className="request-ebill-page">
            <p className="page-sub-header semi-bold-text">REQUEST EBILL</p>

            <PageLayoutContainer>
                <div className="flex-container flex-vertical flex-width">
                    <div className="flex-height flex-container flex-vertical upper-content-container">
                        {/* BillerView cannot be loaded without initializing something from model */}
                        <BillerView biller={ biller } />
                    </div>
                    
                    <div className="flex-height flex-width flex-container all-center">
                        <CenterColumnContainer>
                          <p>eBills let you view and pay your bills in one place. You'll get an email notification when your bill is due.</p>
                          
                          <DisabledPrompt>
                            <div className="flex-container flex-horizontal align-center ebills-dropdown clickable">
                              <SVGAsset id="RightChevronIcon" className="left-icon" />
                              <b>More about eBills</b>
                            </div>
                          </DisabledPrompt>
                          
                          {/* <p>Select how you would like to set up your eBill service:</p>
                          <div className="radio-group flex-container flex-vertical">
                            <div className="radio-item flex-container flex-horizontal align-center">
                              <input type="radio" />
                              <label>Immediate suppression</label>
                            </div>
                            <div className="radio-item flex-container flex-horizontal align-center">
                              <input type="radio" />
                              <label>Trial period</label>
                            </div>
                          </div>
                          <RequestEBillWidget title="Confirm your eBill account number">
                            <p>[Supporting account number text]</p>
                          </RequestEBillWidget>
                          <UITextInput placeHolder="Account number">
                            Helper Text
                          </UITextInput>
                          <UITextInput placeHolder="Confirm account number">
                            Helper Text
                          </UITextInput> */}

                          <RequestEBillWidget title="Confirm your identity">
                            <p>Confirm your identity to { biller.name } by providing the following information.</p>
                          </RequestEBillWidget>

                          <UITextInput className="zip-code" placeHolder="Zip Code" value={ biller.zip } dataPoint="Zip_Code_Input"/>

                          {/* <UITextInput placeHolder="Email address">
                            Helper Text
                          </UITextInput>
                          <UITextInput placeHolder="Last 4 digits of SSN">
                            Helper Text
                          </UITextInput> */}

                          <RequestEBillWidget className="confirm-address" title="Confirm your service address">
                            <p>Enter a U.S. address where you receive your services. If you don't have a U.S. address, call us.</p>
                            <LayoutContainer>
                              <LeftColumnContainer>
                                <p data-point="Address_Line_0">{profile.address}</p>
                                <p>{profile.city}, {profile.state} {profile.zip}</p>
                                <p>Phone {profile.phone}</p>
                              </LeftColumnContainer>
                              <RightColumnContainer>
                                <div className="flex-container flex-horizontal align-center justify-right">
                                  <DisabledPrompt> 
                                    <Link to="/" dataPoint="Edit_Link"><SVGAsset id="EditIcon" className="blue-icon left-icon link" /><span>Edit</span></Link>
                                  </DisabledPrompt>
                                </div>
                              </RightColumnContainer>
                            </LayoutContainer>
                          </RequestEBillWidget>

                          {/* <RequestEBillWidget title="Additional biller message">
                            <p>By enrolling in this service, you agree to receive your bills electronically and not in the mail. Once you submit this request, we'll review your information and determine whether we can send you eBills. It may take one or two months to stop getting paper bills. If you want to get your paper bills again, you can cancel your eBill service or call us.</p>
                          </RequestEBillWidget> */}

                          {/* <h4>Additional biller message</h4>
                          <LayoutContainer>
                            <LeftColumnContainer>
                              <p>This is a test.</p>
                            </LeftColumnContainer>
                            <RightColumnContainer>
                              <div className="flex-container flex-horizontal align-center justify-right">
                                <SVGAsset id="EditIcon" className="blue-icon left-icon" />
                                <DisabledPrompt> <Link to="/">Edit</Link></DisabledPrompt>
                              </div>
                            </RightColumnContainer>
                          </LayoutContainer> */}

                          {/* <TOSWidget />

                          <RequestEBillWidget title="Terms of service">
                            <p>By selecting Request eBills, I acknowledge that I have read and agree to the <Link to="/">eBills Service Agreement.</Link></p>
                          </RequestEBillWidget> */}
                      <EBillBottomButtons submit={submit}/>
                      </CenterColumnContainer>
                    </div>
                </div>
            </PageLayoutContainer>
        </PageView>
  );
}
function EBillBottomButtons(props) {
  let navigate = useRoute();
  let routeData = useRouteData();
  let goBack = () => {
    if (routeData.route === null ) {
      navigate(`/`)
    }else{
      navigate(-1)
    }
  }
  return (
    <ButtonContainer className="request-ebills-button-container form-button-container button-container flex-container flex-horizontal">
      <UIButton className="secondary-button">
        <ModalOpen id="WantToLeaveModal" data={ {onLeave: goBack} }>Don't request eBills</ModalOpen>
      </UIButton>
      <UIButton className="primary-button" onClick={ props.submit } dataPoint="Request_Ebills">Request eBills</UIButton>
    </ButtonContainer>

  );
}